// ----------------- START PURCHASE SCRIPT ------------------------------------
// `breeze-purchase` event listener
window.addEventListener("breeze-purchase", (event) => {
  const eventData = event.detail;
  breezePurchase(eventData);
});
// This function will be invoked by breeze after purchase
function breezePurchase(payload) {
  try {
    merchantPurchaseCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants purchase script : ", e);
  }
}
// merchant script for `purchase` will be pasted here
function merchantPurchaseCustomCode(params) {
  console.log("@@@ start purchase");

  // START OF MERCHANT CENTER CODE
  gtag("event", "purchase", {
    send_to: ["AW-853721859/DGbOCPfGkIsBEIOGi5cD", "MC-17PKS54KN8"],
    transaction_id: params.shopOrderId,
    value: params.totalPrice,
    currency: params.currency,
    shipping: params.shippingCharge,
    items: convertToMerchantParams(params.items),
    breeze_event_type: "breeze_purchase",
    breeze_event_time: new Date().toISOString(),
  });
  function convertToMerchantParams(items) {
    return items.map((item) => {
      return {
        id: item.id,
        name: item.name,
        price: item.price,
        quantity: item.quantity,
        variant: item.variant,
      };
    });
  }
  // END OF MERCHANT CENTER CODE
  // start order complete event
  gtag("event", "Completed Order", {
    event_category: "EnhancedEcommerce",
    send_to: "G-Y04YBDPJ2F",
    breeze_event_type: "breeze_complete_order",
    breeze_event_time: new Date().toISOString(),
  });
  // end order complete event
  console.log("@@@ end purchase");
}
// ----------------- END PURCHASE SCRIPT --------------------------------------

// ----------------- START ADD_PAYMENT_INFO SCRIPT ----------------------------
// `breeze-add-payment-info` event listener
window.addEventListener("breeze-add-payment-info", (event) => {
  const eventData = event.detail;
  breezeAddPaymentInfo(eventData);
});
// This function will be invoked by breeze after add payment info
function breezeAddPaymentInfo(payload) {
  try {
    merchantAddPaymentInfoCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants add Payment info script : ", e);
  }
}
// merchant script for `add_payment_info` will be pasted here
function merchantAddPaymentInfoCustomCode(params) {
  console.log("@@@ start add payment info");

  // initializing
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "AW-853721859");

  // START OF MERCHANT CENTER CODE
  gtag("event", "add_payment_info", {
    send_to: "AW-853721859/WB-8CIbHkIsBEIOGi5cD",
    transaction_id: params.shopOrderId,
    value: params.totalPrice,
    currency: params.currency,
    shipping: params.shippingCharge,
    items: convertToMerchantParams(params.items),
    breeze_event_type: "breeze_add_payment_info",
    breeze_event_time: new Date().toISOString(),
  });

  gtag("event", "page_view", {
    send_to: ["AW-853721859/bu18CLHFkIsBEIOGi5cD", "MC-17PKS54KN8"],
    page_path: "/checkout/processing",
    page_title: "Checkout - Processing",
    page_location: window.location.href,
    ignore_referrer: "true",
    breeze_event_type: "breeze_page_view",
    breeze_event_time: new Date().toISOString(),
  });

  function convertToMerchantParams(items) {
    return items.map((item) => {
      return {
        id: item.id,
        name: item.name,
        price: item.price,
        quantity: item.quantity,
        variant: item.variant,
      };
    });
  }
  console.log("@@@ end add payment info");
}
// ----------------- END ADD_PAYMENT_INFO SCRIPT ------------------------------
// ----------------- START BEGIN_CHECKOUT SCRIPT ------------------------------
// `breeze-initiate-checkout` event listener
window.addEventListener("breeze-initiate-checkout", (event) => {
  const eventData = event.detail;
  breezeInitiateCheckout(eventData);
});
// This function will be invoked by breeze after begin checkout
function breezeInitiateCheckout(payload) {
  try {
    merchantInitiateCheckoutCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants initiate checkout script : ", e);
  }
}
// merchant script for `begin_checkout` will be pasted here
function merchantInitiateCheckoutCustomCode(params) {
  console.log("@@@ start initiate checkout");
  // initializing
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "AW-853721859");
  // START OF MERCHANT CENTER CODE
  gtag("event", "begin_checkout", {
    send_to: "AW-853721859/xRoKCIDHkIsBEIOGi5cD",
    transaction_id: params.shopOrderId,
    value: params.totalPrice,
    currency: params.currency,
    shipping: params.shippingCharge,
    items: convertToMerchantParams(params.items),
    breeze_event_type: "breeze_checkout_initiated",
    breeze_event_time: new Date().toISOString(),
  });
  function convertToMerchantParams(items) {
    return items.map((item) => {
      return {
        id: item.id,
        name: item.name,
        price: item.price,
        quantity: item.quantity,
        variant: item.variant,
      };
    });
  }
  console.log("@@@ end initiate checkout");
}
// ----------------- END BEGIN_CHECKOUT SCRIPT --------------------------------
